import * as actions from '../actions/actionTypes';

const initialState = {
  holidays: [],
};

const fetchHolidaysSuccess = (state, action) => ({ ...state, holidays: action.holidays });

const createHolidaySuccess = (state, action) => ({
  ...state,
  holidays: state.holidays.concat(action.holiday),
});

const deleteHolidaySuccess = (state, action) => ({
  ...state,
  holidays: state.holidays.filter(holiday => holiday.id !== action.id),
});

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.FETCH_HOLIDAYS_SUCCESS:
      return fetchHolidaysSuccess(state, action);
    case actions.CREATE_HOLIDAY_SUCCESS:
      return createHolidaySuccess(state, action);
    case actions.DELETE_HOLIDAY_SUCCESS:
      return deleteHolidaySuccess(state, action);
    default:
      return state;
  }
};

export default reducer;
